import {
  saveInspectTaskAndItemApi,
  setInspectTaskConfigApi,
  addInspectTaskAndConfigApi,
  updateInspectTaskAndConfigApi,
  setInspectTaskIsValidApi,
  getInspectTaskAndItemListByIdApi,
  queryInspectTaskApi,
  queryElmPidApi,
  saveOrUpdateElmPidApi,
  updateElmPidStatusApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  保存检查任务和条目
  async saveInspectTaskAndItemAction(context, param) {
    const res = await saveInspectTaskAndItemApi(param)
    return res
  },
  //  设置检查任务配置
  async setInspectTaskConfigAction(context, param) {
    const res = await setInspectTaskConfigApi(param)
    return res
  },
  //  添加检查任务和配置
  async addInspectTaskAndConfigAction(context, param) {
    const res = await addInspectTaskAndConfigApi(param)
    return res
  },
  //  更新检查任务和配置
  async updateInspectTaskAndConfigAction(context, param) {
    const res = await updateInspectTaskAndConfigApi(param)
    return res
  },
  //  设置检查任务是否有效
  async setInspectTaskIsValidAction(context, param) {
    const res = await setInspectTaskIsValidApi(param)
    return res
  },
  //  根据id获取检查任务条目列表
  async getInspectTaskAndItemListByIdAction(context, param) {
    const res = await getInspectTaskAndItemListByIdApi(param)
    return res
  },
  //  查询检查任务
  async queryInspectTaskAction(context, param) {
    const res = await queryInspectTaskApi(param)
    return res
  },
  //  饿了么pid查询
  async queryElmPidAction(context, param) {
    const res = await queryElmPidApi(param)
    return res
  },
  //  新增/更新饿了么pid
  async saveOrUpdateElmPidAction(context, param) {
    const res = await saveOrUpdateElmPidApi(param)
    return res
  },
  //  更新饿了么pid状态
  async updateElmPidStatusAction(context, param) {
    const res = await updateElmPidStatusApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
